"use client";

import Color from "@faire/web--source/slate/Color";
import type { IconName as FoundationIconsName } from "@faire/web--source/slate/icons/__generated__/foundationIcons";
import { SVGIcon } from "@faire/web--source/slate/icons/SVGIcon";
import React, { type JSX } from "react";

type Direction = "up" | "down" | "left" | "right" | "upAndRight";

export interface IFoundationIconProps {
  iconName: FoundationIconsName;
  fontSize?: number;
  color?: Color;
  direction?: Direction;
}

// this icon wrapper is for Builder to render icon
export const FoundationIcon = ({
  iconName,
  fontSize,
  color,
  direction,
}: IFoundationIconProps) => {
  const [element, setElement] = React.useState<JSX.Element>();

  React.useEffect(() => {
    let lazyload:
      | undefined
      | Promise<
          Record<
            string,
            (
              props: Partial<
                SVGIcon.IProps & SVGElement & { direction: Direction }
              >
            ) => JSX.Element
          >
        > = undefined;

    lazyload = import(
      "@faire/web--source/slate/icons/__generated__/foundationIcons"
    ) as any;

    if (lazyload) {
      lazyload.then((module) => {
        const Icon = module[iconName]!;
        setElement(
          <Icon
            fontSize={`${fontSize}px`}
            color={color}
            direction={direction}
          />
        );
      });
    }
  }, [color, direction, fontSize, iconName]);

  return element;
};
